// The line at the top of a DM when someone's own AI can read it (docs/connector.md "Messages"): "Sam's Claude Code
// can read this conversation". Asked of the server each time a DM opens (GET /api/connector/dm-readers), which applies
// the same rule as the connector. AIs never send in DMs, so this only ever says "read".
import { useEffect, useState } from "react";
import type { DmReader } from "@bloom/shared";
import { api } from "../api.ts";

/** "Your Claude Code and Sam's Claude can read this conversation." */
export function dmReadersLine(readers: DmReader[], me: string, names: Map<string, string>): string | null {
  if (!readers.length) return null;
  const who = readers.map((r) => (r.userId === me ? `your ${r.client}` : `${names.get(r.userId) ?? "Someone"}'s ${r.client}`));
  const list = who.length === 1 ? who[0]! : `${who.slice(0, -1).join(", ")} and ${who.at(-1)}`;
  return `${list[0]!.toUpperCase()}${list.slice(1)} can read this conversation.`;
}

export function DmAiNotice({ serverId, channelId, me, names }: { serverId: string; channelId: string; me: string; names: Map<string, string> }) {
  const [readers, setReaders] = useState<DmReader[]>([]);
  useEffect(() => {
    let live = true;
    setReaders([]);
    api<DmReader[]>(`/connector/dm-readers?server=${encodeURIComponent(serverId)}&channel=${encodeURIComponent(channelId)}`).then(
      (r) => live && setReaders(r),
      () => {},
    );
    return () => {
      live = false;
    };
  }, [serverId, channelId]);
  const line = dmReadersLine(readers, me, names);
  if (!line) return null;
  return (
    <div className="dm-ai-notice" role="note">
      {line} AIs never send messages here. <span className="muted">You can turn off other people's AIs in Settings → Connected apps & AI.</span>
    </div>
  );
}
